export const phoneMask = "(##) #####-####"
export const zipcodeMask = "#####-###"
export const numberMask = "#####"
export const creditCardNumberMask = "#### #### #### ####"
export const creditCardExpirationDate = "##/##"
export const cpfMask = "###.###.###-##"
export const moneyMaskConfig = {
    prefix: 'R$ ',
    thousands: '',
    decimal: ',',
    precision: 0,
    disableNegative: true,
    minimumNumberOfCharacters: 1,
    modelModifiers: {
        number: true
    }
}